import { useEffect, useState } from "react";

/*
 * useStringLoop hook
 * Loops through an array of strings and returns the current string - used in loading skeletons
 */
export const useStringLoop = (displayStrings: string[], delay: number = 2000) => {
  /* State */
  const [displayString, setDisplayString] = useState(displayStrings[0]);

  /* Side effects */
  useEffect(() => {
    const interval = setInterval(() => {
      setDisplayString((prev) => {
        const index = displayStrings.indexOf(prev);
        const nextIndex = index === displayStrings.length - 1 ? 0 : index + 1;
        return displayStrings[nextIndex];
      });
    }, delay);

    return () => clearInterval(interval);
  }, [displayStrings, delay]);

  /* Return */
  return displayString;
};
